import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, LogOut, Package } from "lucide-react";
import { API } from "@/lib/api";
import { shopApi, useShopAuth } from "@/lib/shopAuth";
import { cartCount, useB2bCart } from "@/lib/b2bCart";

export default function RedfoxLayout({ store, children }) {
  const auth = useShopAuth();
  const customer = auth?.customer;
  const navigate = useNavigate();
  useB2bCart();
  const count = cartCount();
  // Branding spójny również na stronach, które nie przekazują `store` (np. Zamówienia, pusty Koszyk).
  const [fetched, setFetched] = useState(null);
  useEffect(() => {
    if (store || !auth?.ready || !customer) return;
    shopApi.get("/b2b/my/stores").then((r) => setFetched((r.data || [])[0] || null)).catch(() => {});
  }, [store, auth?.ready, customer]);
  const s = store || fetched;

  return (
    <div className="min-h-screen flex flex-col text-neutral-100" style={{ fontFamily: "'Inter','Helvetica Neue',sans-serif", backgroundColor: "#0a0a0b", backgroundImage: "repeating-linear-gradient(135deg, rgba(255,255,255,0.02) 0 2px, transparent 2px 9px)" }} data-testid="redfox-layout">
      <div className="h-1 w-full" style={{ background: "#E4122A" }} />
      <header className="sticky top-0 z-40 border-b border-red-600/30 bg-[#0a0a0b]/90 backdrop-blur">
        <div className="mx-auto max-w-6xl px-4 h-16 flex items-center justify-between gap-4">
          <Link to="/sklep/moj-sklep" data-testid="redfox-home" className="flex items-center gap-3 min-w-0">
            {s?.logo_file_id
              ? <img src={`${API}/files/${s.logo_file_id}`} alt={s?.name || "Sklep"} className="h-9 w-auto max-w-[160px] object-contain" />
              : <span className="uppercase tracking-[0.18em] text-xl truncate italic" style={{ fontFamily: "'Oswald',sans-serif", fontWeight: 700 }}>{s?.name || "Mój sklep"}</span>}
          </Link>
          <nav className="flex items-center gap-2 sm:gap-4">
            <Link to="/sklep/moj-sklep/zamowienia" data-testid="redfox-orders-link" className="flex items-center gap-1.5 text-sm font-medium text-neutral-300 hover:text-white transition-colors">
              <Package className="h-4 w-4" /><span className="hidden sm:inline">Zamówienia</span>
            </Link>
            <Link to="/sklep/moj-sklep/koszyk" data-testid="redfox-cart-link" className="relative flex items-center gap-2 rounded-full bg-red-600 px-4 py-2 text-white font-semibold text-sm hover:bg-red-500 transition-colors">
              <ShoppingBag className="h-4 w-4" />Koszyk
              {count > 0 && <span data-testid="redfox-cart-count" className="absolute -top-1.5 -right-1.5 grid h-5 min-w-5 place-items-center rounded-full bg-white px-1 text-[11px] font-bold text-red-600">{count}</span>}
            </Link>
            {customer && (
              <button data-testid="redfox-logout" onClick={() => { auth.logout(); navigate("/sklep"); }} title="Wyloguj" className="text-neutral-400 hover:text-white transition-colors">
                <LogOut className="h-5 w-5" />
              </button>
            )}
          </nav>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-red-600/20 py-8 text-center text-xs text-neutral-500">
        <p>{s?.name || "Sklep"} — sklep prowadzony przez EMPRO.</p>
      </footer>
    </div>
  );
}
